import { QMASLazyDocument } from 'app/modules/ui';

export const DESCRIPTION_DEF = [
  {
    label: 'Important Remarks / Attachments Progress',
    dataIndex: 'progress',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: 'Attachments',
    dataIndex: 'attachments',
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return (
          <>
            {value.map((item, index) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </>
        );
      }
      return <QMASLazyDocument alt="attachments" documentId={value} />;
    }
  }
];
